import React from "react";
import "./HolidayViewMore.css";
import { useNavigate } from "react-router-dom";
import shimla from "../../assets/shimla.jpg";
import udaipur from "../../assets/udaipur.jpg";
import jaisalmer from "../../assets/jaisalmer.jpg";
import manali from "../../assets/manali.png";
import goa from "../../assets/goa.png";
import kerala from "../../assets/kerala.png";
import ladakh from "../../assets/ladakh.png";
import rishikesh from "../../assets/rishikesh.png";
import andaman from "../../assets/andaman.png";

const trips = [
  {
    img: shimla,
    tag: "Popular",
    name: "Shimla",
    days: "7 Days - All-Inclusive",
    link: "/tour-package-data",
  },
  {
    img: udaipur,
    tag: "Top Rated",
    name: "Udaipur",
    days: "5 Days - Adventure",
    link: "/tour-package-data",
  },
  {
    img: jaisalmer,
    tag: "Cultural",
    name: "Jaisalmer",
    days: "3 Days - Cultural",
    link: "/tour-package-data",
  },

  {
    img: manali,
    tag: "Popular",
    name: "Manali",
    days: "6 Days - Snow Fun",
    link: "/tour-package-data",
  },
  {
    img: goa,
    tag: "Top Rated",
    name: "Goa",
    days: "4 Days - Beach Holiday",
    link: "/tour-package-data",
  },
  {
    img: kerala,
    tag: "Relax",
    name: "Kerala",
    days: "5 Days - Backwaters",
    link: "/tour-package-data",
  },

  {
    img: ladakh,
    tag: "Adventure",
    name: "Ladakh",
    days: "8 Days - Bike Trip",
    link: "/tour-package-data",
  },
  {
    img: rishikesh,
    tag: "Spiritual",
    name: "Rishikesh",
    days: "3 Days - Yoga Retreat",
    link: "/tour-package-data",
  },
  {
    img: andaman,
    tag: "Island",
    name: "Andaman",
    days: "6 Days - Island Escape",
    link: "/tour-package-data",
  },
];

const HolidayViewMore = () => {
  const navigate=useNavigate()
  return (
    <div className="trips-main">
      <div className="trips-grid">
        {trips.map((trip, index) => (
          <div
            className="trip-cardd"
            key={index}
            onClick={() =>
              navigate(trip.link, {
                state: { title:trip.name },
              })
            }
          >
            <div className="trip-img-wrapper">
              <img src={trip.img} alt={trip.name} />

              <span className="trip-tag">{trip.tag}</span>
            </div>

            <div className="trip-content">
              <h3>{trip.name}</h3>
              <h2>{trip.days}</h2>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HolidayViewMore;
